import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const ConfigIcon = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 19 17"
    style={{ fill: 'none', width: '21px', height: '21px', strokeWidth: '.08rem' }}
  >
    <path
      d="M16.5943 8.3476C18.0937 7.02393 18.3936 4.97224 17.4939 3.31766L15.0198 5.50171H12.9956V3.64857L15.3947 1.46452C13.5954 0.670319 11.1963 0.868869 9.6968 2.25872C8.19735 3.58239 7.82249 5.63408 8.79713 7.28867L1.44983 13.7746C0.850055 14.3041 0.850055 15.0983 1.44983 15.6278C2.04961 16.1572 2.94928 16.1572 3.54906 15.6278L10.8964 9.1418C12.7707 9.936 15.0198 9.67127 16.5943 8.3476Z"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default ConfigIcon;
